import { gettext } from '@eventbrite/i18n';
import React from 'react';
import styles from './AgendaTitle.module.scss';

export const AgendaTitle = () => (
    <div className={styles.agendaTitle}>{gettext('Agenda')}</div>
);
